import Vue from 'vue';
import App from './App.vue';
import router from './router';

// Bootstrap & bootstrap vue
import 'bootstrap';
//import 'bootstrap/dist/css/bootstrap.css';

import BootstrapVue from 'bootstrap-vue';
Vue.use(BootstrapVue)

// Vue google maps
import * as VueGoogleMaps from 'vue2-google-maps';
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBi9GjagUNukUsvQkyL738IPvX_wd3NhMI',
  },
});

// vue-clipboard2
import VueClipboard from 'vue-clipboard2';
Vue.use(VueClipboard);

// vue-mq
import VueMq from 'vue-mq';
Vue.use(VueMq, {
  breakpoints: {
    mobile: 768,
    desktop: Infinity
  },
  defaultBreakpoint: 'desktop'
});

// vue tagsinput
import VoerroTagsInput from '@voerro/vue-tagsinput';
Vue.component('tags-input', VoerroTagsInput);
import '@voerro/vue-tagsinput/dist/style.css';

//vue-select
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
Vue.component('v-select', vSelect)

// Font Awesome
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far} from '@fortawesome/free-regular-svg-icons';
import { fab} from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
library.add(fas, fab, far);

Vue.component('font-awesome-icon', FontAwesomeIcon);

// vue-slider-component css
import 'vue-slider-component/theme/default.css'

// custom CSS
import './assets/css/admin-ui.css';

// tippy CSSs
import 'tippy.js/themes/light.css';
import 'tippy.js/themes/light-border.css';
import 'tippy.js/themes/google.css';
import 'tippy.js/themes/translucent.css';

// glyphicons
import './assets/css/glyphicons.css';

// veevalidate v3
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

import { ValidateRules } from './util/ValidateRules';

import {Chart, ChartData, ChartItem, registerables} from "chart.js";
import 'chartjs-adapter-luxon';
import zoomPlugin from 'chartjs-plugin-zoom';

Chart.register(zoomPlugin);

// Validation rules
import { required, email, regex, between, min, min_value, max_value, confirmed } from 'vee-validate/dist/rules';
extend('confirmed', {...confirmed, message:'The {_field_} field confirmation does not match'});
extend('between', {...between, message:'The {_field_} field must be between {min} and {max}'});
extend('regex', {...regex, message:'The {_field_} field format is invalid'});
extend('required', {...required, message:'The {_field_} field is required'});
extend('min', {...min, message:'The {_field_} field must be at least {length} characters'});
extend('min_value', {...min_value, message:'The {_field_} field must be {min} or more'});
extend('max_value', {...max_value, message:'The {_field_} field must be {max} or less'});
extend('email', {...email, message:'The {_field_} field must be a valid email'});
extend('url', ValidateRules.url);
extend('httpHeaders', ValidateRules.httpHeaders);
extend('awsAccessKeyId', ValidateRules.awsAccessKeyId);
extend('awsSecretAccessKey', ValidateRules.awsSecretAccessKey);
extend('awsRegion', ValidateRules.awsRegion);
extend('snsTopicArn', ValidateRules.snsTopicArn);
extend('kinesisStreamName', ValidateRules.kinesisStreamName);
extend('azureEventHubConnectionString', ValidateRules.azureEventHubConnectionString);
extend('azureEventHubName', ValidateRules.azureEventHubName);
extend('ubidotsToken', ValidateRules.ubidotsToken);
extend('integerBetween', ValidateRules.integerBetween);
extend('deviceName', ValidateRules.deviceName);
extend('locationName', ValidateRules.locationName);
extend('apiKeyDescription', ValidateRules.apiKeyDescription);
extend('hex', ValidateRules.hex);
extend('hexRaw', ValidateRules.hexRaw);
extend('loraParserName', ValidateRules.loraParserName);
extend('iotCoreEndpointUrl', ValidateRules.iotCoreEndpointUrl);

Vue.config.productionTip = false;

// global filters
import { FilterUtil } from './util/FilterUtil';
const filterUtil = new FilterUtil();
Vue.filter('formatDeviceType', filterUtil.formatDeviceType);
Vue.filter('formatGroupId', filterUtil.formatGroupId);
Vue.filter('tsToString', filterUtil.tsToString);
Vue.filter('tsToAgo', filterUtil.tsToAgo);
Vue.filter('formatBytes', filterUtil.formatBytes);
Vue.filter('formatDuration', filterUtil.formatDuration);
Vue.filter('maskFieldStars', filterUtil.maskFieldStars);
Vue.filter('maskFieldEllipsis', filterUtil.maskFieldEllipsis);
Vue.filter('underscoreToSpaces', filterUtil.underscoreToSpaces);
Vue.filter('safeTruncate', filterUtil.safeTruncate);
Vue.filter('smartFormatValue', filterUtil.smartFormatValue);


// Vue CTK Date time picker
// @ts-ignore
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';

Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker);

new Vue({
  router,
  render: (h:any) => h(App),
}).$mount('#app');
